import { addYears } from '@e3dc-react/shell/Libs/date'
import { TariffCategory, TariffStatusType } from '../../shared/models/types'
import { WallboxModel } from '../../wallboxes/models/wallbox-model'
import { MOCK_CURRENCY, MOCK_WALLBOX_NAME } from './mock-properties'

const MOCK_END_TIME = addYears(new Date(), 2).toISOString()

export const MOCK_WALLBOX_WITH_ASSIGNED_TARIFF_AND_TOKENS: WallboxModel = {
  activeTariff: {
    currencyCode: MOCK_CURRENCY,
    dischargePrice: 0,
    dynamicPrices: [],
    endTime: MOCK_END_TIME,
    startTime: '2022-11-04T23:00:00',
    staticPrices: { gridPrice: 11.9978, solarPrice: 0 },
    tariffCategory: TariffCategory.staticTariff,
    tariffId: 'a88826fa-c47f-4ac0-9b13-116e03ab0874',
    tariffName: 'Tariff 2',
    tariffStatus: TariffStatusType.active,
  },
  expiredTariffs: [],
  inactiveTariffs: [],
  midMeter: 'NO_MID_METER_INSTALLED',
  tariffToDisplay: {
    currencyCode: MOCK_CURRENCY,
    dischargePrice: 0,
    dynamicPrices: [],
    endTime: MOCK_END_TIME,
    startTime: '2022-11-04T23:00:00',
    staticPrices: { gridPrice: 11.9978, solarPrice: 0 },
    tariffCategory: TariffCategory.staticTariff,
    tariffId: 'a88826fa-c47f-4ac0-9b13-116e03ab0874',
    tariffName: 'Tariff 2',
    tariffStatus: TariffStatusType.active,
  },
  wallboxId: '00141648D8EAB801',
  wallboxName: MOCK_WALLBOX_NAME,
  wallboxType: 5,
  useMidMeter: true,
}
